/**
 * Sidebar collapsed state store.
 *
 * Controls sidebar width (240px expanded, 64px collapsed icon rail).
 * Used by AppLayout for content margin and Sidebar for width animation.
 */
import { create } from 'zustand';

export interface SidebarState {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (v: boolean) => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  collapsed: false,
  toggle: () => set((s) => ({ collapsed: !s.collapsed })),
  setCollapsed: (collapsed) => set({ collapsed }),
}));
